export const COMPLETE_STEP = "intro/COMPLETE_STEP";
export const SUBMITTER_IS_CONTRIBUTOR_CHANGED = "intro/SUBMITTER_IS_CONTRIBUTOR_CHANGED";
export const LOCAL_STORAGE_SYNCED = "intro/LOCAL_STORAGE_SYNCED";
export const LOCAL_STORAGE_LOADED = "intro/LOCAL_STORAGE_LOADED";


export const COUNTRIES_LOADED = "intro/COUNTRIES_LOADED";
export const COUNTRY_CHANGED = "intro/COUNTRY_CHANGED";
export const FIELD_BLURRED = "intro/FIELD_BLURRED";
export const FIELD_CHANGED = "intro/FIELD_CHANGED";
export const LIBRARIES_LOADED = "intro/LIBRARIES_LOADED";
export const LOCAL_LIBRARY_CHANGED = "intro/LOCAL_LIBRARY_CHANGED";
export const REGION_CHANGED = "intro/REGION_CHANGED";
export const ROLES_LOADED = "intro/ROLES_LOADED";
export const ROLE_CHANGED = "intro/ROLE_CHANGED";
export const SUBDIVISIONS_LOADED = "intro/SUBDIVISIONS_LOADED";

export const countriesLoaded = countries => ({
  type: COUNTRIES_LOADED,
  countries,
});

export const librariesLoaded = libraries => ({
  type: LIBRARIES_LOADED,
  libraries,
});

export const subdivisionsLoaded = subdivisions => ({
  type: SUBDIVISIONS_LOADED,
  subdivisions,
});

export const loadSudivisions = countryCode => ({
  type: LOCAL_STORAGE_LOADED,
  countryCode,
});

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});

export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });
